import { type ReferenceData } from '@apps/web/components/phoebe_chat/assistant_response_types';
import { type StagedReference } from '@apps/web/lib/chat_reference_store';
import { formatDate } from '@apps/web/lib/date_utils';

export function stagedReferenceToReferenceData(
    reference: StagedReference,
    timezone: string,
): ReferenceData {
    if (reference.type !== 'shift') {
        return {
            type: reference.type,
            id: reference.id,
            display_name: reference.displayName,
        };
    }
    const { shift } = reference;
    // Mirror the backend's enriched reference shape
    // (references.py _resolve_shift_references) so the optimistic pill
    // matches the server-echoed one.
    const shiftDate = formatDate(shift.shift_start_time, timezone);
    return {
        type: 'shift',
        id: shift.id,
        display_name: shift.patient_name
            ? `${shift.patient_name}, ${shiftDate}`
            : `Shift on ${shiftDate}`,
        metadata: {
            patient_name: shift.patient_name,
            shift_start_time: shift.shift_start_time,
            shift_end_time: shift.shift_end_time,
            timezone,
            status: shift.status,
        },
    };
}
